var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolution2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 25C63 26.1046 62.1046 27 61 27H47C45.8954 27 45 26.1046 45 25V11C45 9.89543 45.8954 9 47 9H61C62.1046 9 63 9.89543 63 11V25ZM49.5 20.5C49.5 21.6046 50.3954 22.5 51.5 22.5H56.5C57.6046 22.5 58.5 21.6046 58.5 20.5V15.5C58.5 14.3954 57.6046 13.5 56.5 13.5H51.5C50.3954 13.5 49.5 14.3954 49.5 15.5V20.5Z",
    fill: "url(#paint0_linear_304_42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8571 34.1429C38.7526 34.1429 37.8571 33.2474 37.8571 32.1429V22C37.8571 20.8954 36.9617 20 35.8571 20H21C19.8954 20 19 20.8954 19 22V51C19 52.1046 19.8954 53 21 53H50C51.1046 53 52 52.1046 52 51V36.1429C52 35.0383 51.1046 34.1429 50 34.1429H39.8571ZM23.7143 26.7143C23.7143 25.6097 24.6097 24.7143 25.7143 24.7143H31.1429C32.2474 24.7143 33.1429 25.6097 33.1429 26.7143V32.1429C33.1429 33.2474 32.2474 34.1429 31.1429 34.1429H25.7143C24.6097 34.1429 23.7143 33.2474 23.7143 32.1429V26.7143ZM33.1429 46.2857C33.1429 47.3903 32.2474 48.2857 31.1429 48.2857H25.7143C24.6097 48.2857 23.7143 47.3903 23.7143 46.2857V40.8571C23.7143 39.7526 24.6097 38.8571 25.7143 38.8571H31.1429C32.2474 38.8571 33.1429 39.7526 33.1429 40.8571V46.2857ZM47.2857 46.2857C47.2857 47.3903 46.3903 48.2857 45.2857 48.2857H39.8571C38.7526 48.2857 37.8571 47.3903 37.8571 46.2857V40.8571C37.8571 39.7526 38.7526 38.8571 39.8571 38.8571H45.2857C46.3903 38.8571 47.2857 39.7526 47.2857 40.8571V46.2857Z",
    fill: "url(#paint1_linear_304_42)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4167 64H12.5833C11.3681 63.9988 10.203 63.5155 9.34377 62.6562C8.48449 61.797 8.00121 60.6319 8 59.4167V13.5833C8.00121 12.3681 8.48449 11.203 9.34377 10.3438C10.203 9.48449 11.3681 9.00121 12.5833 9H33.5C34.6046 9 35.5 9.89543 35.5 11V11.5833C35.5 12.6879 34.6046 13.5833 33.5 13.5833H14.5833C13.4788 13.5833 12.5833 14.4788 12.5833 15.5833V57.4167C12.5833 58.5212 13.4788 59.4167 14.5833 59.4167H56.4167C57.5212 59.4167 58.4167 58.5212 58.4167 57.4167V38.5C58.4167 37.3954 59.3121 36.5 60.4167 36.5H61C62.1046 36.5 63 37.3954 63 38.5V59.4167C62.9988 60.6319 62.5155 61.797 61.6562 62.6562C60.797 63.5155 59.6319 63.9988 58.4167 64Z",
    fill: "url(#paint2_linear_304_42)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_42",
    x1: 45,
    y1: 18.0004,
    x2: 62.9993,
    y2: 18.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_304_42",
    x1: 19,
    y1: 36.5006,
    x2: 51.9987,
    y2: 36.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_304_42",
    x1: 8,
    y1: 36.5011,
    x2: 62.9978,
    y2: 36.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution2);
export default __webpack_public_path__ + "static/media/solution2.94a2527f285ca8c706fd1ccdecdef424.svg";
export { ForwardRef as ReactComponent };